// extracted by mini-css-extract-plugin
module.exports = {"header":"MicroCard_header__PeRGi","wrapper":"MicroCard_wrapper__4t8ND","micro":"MicroCard_micro__w6slJ"};